export default __webpack_public_path__ + "fonts/f6369209d41d110590f31bd2f3773080.svg";